import { createSlice } from '@reduxjs/toolkit';
import { addUser, fetchUsers, updateUser,uploadCsvFile } from './userThunks';
import { User } from '../../types/User'

export interface UserState {
  users: User[];
  loading: boolean;
  error: string | null;
  uploadResult?: any;
}
export const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
   uploadResult: undefined,

};

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearUsers: (state) => {
      state.users = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload; // חובה לשים!
       state.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Error in fetching users';
      })
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users.push(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.users.findIndex((u) => u.id === action.payload.id);
        if (index !== -1) {
          state.users[index] = action.payload;
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Update failed';
      })
      .addCase(uploadCsvFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadCsvFile.fulfilled, (state, action) => {
        console.log(action.payload); // כאן תראה את התשובה
        state.uploadResult = action.payload;
      })
      .addCase(uploadCsvFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Update failed';
      });

  },
});

export const { clearUsers } = userSlice.actions;
export default userSlice.reducer;
